// Site service-profile (1:1), keyed by bare site_slug:
//   GET|PUT|DELETE /api/v1/sites/{site_slug}/service-profile

import { request, type ApiResponse } from "../client";
import type { ServiceProfileConfig, ServiceProfileIn } from "../types/siteServiceProfile";

const path = (s: string) => `/api/v1/sites/${encodeURIComponent(s)}/service-profile`;

export const siteServiceProfile = {
  get: (siteSlug: string): Promise<ApiResponse<ServiceProfileConfig>> =>
    request<ServiceProfileConfig>("GET", path(siteSlug)),
  put: (siteSlug: string, body: ServiceProfileIn): Promise<ApiResponse<ServiceProfileConfig>> =>
    request<ServiceProfileConfig>("PUT", path(siteSlug), body),
  remove: (siteSlug: string): Promise<ApiResponse<void>> =>
    request<void>("DELETE", path(siteSlug)),
};
